import React from 'react';
import BoostedComponent from './BoostedComponent'
import moment from 'moment-with-locales-es6';

class ReservationSeuleJour extends BoostedComponent {
  constructor (props) {
    super(props)
    this.state = {
      activite: [],
      jour: this.props.jourChoisi
    }
    this.constants = this.props.constants;
    this.generateList(this.state.activite).sort((a,b)=>(a.debut>b.debut ? 1 : -1)).filter(t=>{
      let tempsDispo = t.fin - t.debut
      let tempsDemande = (this.string2temps(this.props.parent.state.heureFin) - this.string2temps(this.props.parent.state.heureDebut))*(60*60)
      return (tempsDispo >= tempsDemande)
    })

    this.maxMonth = this.constants.moisMax
  }
  componentDidUpdate(prevProps,prevState) {
    if (Array.isArray(this.props.jourChoisi) && prevProps.jourChoisi !== this.props.jourChoisi || this.props.activite !== prevProps.activite){

      let debutChoisi = Date.UTC(this.props.jourChoisi[0],this.props.jourChoisi[1],this.props.jourChoisi[2],0,0,0,0)/1000

      this.setState({
        activites: this.props.activites.map(i=>{return {plateau_ID: parseInt(i.plateau_ID,10), debut: parseInt(i.debut,10),fin: parseInt(i.fin,10)}}).filter(i => {
          if (i.debut > debutChoisi + 24*60*60 || i.fin < debutChoisi) return false;
          return true;
        }),
        jour: this.props.jourChoisi,
        plagechoix: ''
      });
      this.generateList(this.state.activite).sort((a,b)=>(a.debut>b.debut ? 1 : -1)).filter(t=>{
        let tempsDispo = t.fin - t.debut
        let tempsDemande = (this.string2temps(this.props.parent.state.heureFin) - this.string2temps(this.props.parent.state.heureDebut))*(60*60)
        return (tempsDispo >= tempsDemande)
      })
    }
    if (prevState.plagechoix !== this.state.plagechoix) {
      if (this.state.plagechoix) {
        let [a,b,c] = this.state.plagechoix.split('-')
        this.selectionPlage(b,c,a)
      }
    }
    if (prevState.jour !== this.state.jour || prevState.activite !== this.state.activite ) {

      let choisi = null;
      this.generateList(this.state.activite).sort((a,b)=>(a.debut>b.debut ? 1 : -1)).filter(t=>{
        let tempsDispo = t.fin - t.debut
        let tempsDemande = (this.string2temps(this.props.parent.state.heureFin) - this.string2temps(this.props.parent.state.heureDebut))*(60*60)
        return (tempsDispo >= tempsDemande)
      })
    } 
  }
  generateList = (e) => {
    if (!this.state.jour || !this.state.activites)
    return [];

    let debut = new Date(Date.UTC(this.state.jour[0],this.state.jour[1],this.state.jour[2],this.constants.options.heureDebut,0,0));
    let fin = new Date(Date.UTC(this.state.jour[0],this.state.jour[1],this.state.jour[2],this.constants.options.heureFin,0));
    debut = debut.getTime()/1000;
    fin = fin.getTime()/1000;

if (fin < debut) {
  fin += 3600*24
}

    let returnPlages = [];
    for (let p=0; p<= this.constants.plateaux.length; p++) {
      let plateau = parseInt(this.constants.plateaux[p]);
      let activites = this.state.activites.filter(i=>(parseInt(i.plateau_ID,10)===plateau)).filter(i=>(i.fin > debut && i.debut < fin)).sort((a,b)=>(a.debut > b.debut ? 1 : -1));
      let plageDebut = debut;
      let plageFin = fin;
      let letConflitDebut = this.state.activites.filter(i=>(i.fin > debut && i.debut < debut));

      
      let filterfunc = (i)=>(i.debut>=plageDebut && i.debut!==i.fin);


      let conflicting = activites.filter(a => (a.debut <= plageDebut && a.fin > plageDebut))
      if (conflicting.length) {
        plageDebut  =conflicting[0].fin
      }
      let loop = 0;  

      while (plageDebut < fin && loop < 200) {
        let newDebut;
        let nextActivite = activites.filter(filterfunc)
        if (nextActivite.length>0) {
          plageFin = nextActivite[0].debut
          newDebut = nextActivite[0].fin;
        } else {
          plageFin = fin;
          newDebut = fin;
        }
        if (plageDebut !== plageFin) {

          returnPlages.push({
            plateau: plateau,
            debut: plageDebut,
            fin: plageFin
          });
        }
        plageDebut = newDebut;
        loop++;
      }
    }
    return returnPlages;

  }
  selectionPlage = (debut,fin,plateau) => {
    this.setState({
      plagechoix: plateau+"-"+debut+"-"+fin
    })
    this.props.parent.setState({
      plageChoisie: [debut,fin,plateau]
    })
  }
  render() {
    moment.locale(this.constants.locale)
    return(
      <div className="ReservationSeule2">

        <h3>{this.constants.plageHoraireDispo}</h3>
        <p>{this.constants.cliquezPourEtapeSuivante}</p>{}

          <table>
            <tbody>
              {this.generateList(this.state.activite).sort((a,b)=>(a.debut>b.debut ? 1 : -1)).filter((t)=>{
                if (!t.plateau) return false;
                let tempsDispo = t.fin - t.debut
                let tempsDemande = (this.string2temps(this.props.parent.state.heureFin) - this.string2temps(this.props.parent.state.heureDebut))*(60*60)
                return (tempsDispo >= tempsDemande)
              }).filter((item,index,tableau)=> {

                let tableauFiltre = tableau.filter(i=> {
                  return (
                    ((parseInt(i.debut)%(24*60*60))/(60*60) <= this.string2temps(this.props.parent.state.heureDebut) &&
                    ((parseInt(i.fin)%(24*60*60))/(60*60)==0 || (parseInt(i.fin)%(24*60*60))/(60*60) >= this.string2temps(this.props.parent.state.heureFin)))
                    || (parseInt(i.fin)%(24*60*60))<(parseInt(i.debut)%(24*60*60)) && 
                    (parseInt(i.debut)%(24*60*60))/(60*60) <= this.string2temps(this.props.parent.state.heureDebut) &&
                    ((parseInt(i.fin)%(24*60*60))/(60*60)+(24*3600) >= this.string2temps(this.props.parent.state.heureFin))
                  )
                })
                if (tableauFiltre.length == 0) return true;
                else return (
                  ((parseInt(item.debut)%(24*60*60))/(60*60) <= this.string2temps(this.props.parent.state.heureDebut) &&
                  ((parseInt(item.fin)%(24*60*60))/(60*60)==0 || (parseInt(item.fin)%(24*60*60))/(60*60) >= this.string2temps(this.props.parent.state.heureFin)))
                  || (parseInt(item.fin)%(24*60*60))<(parseInt(item.debut)%(24*60*60)) && 
                  (parseInt(item.debut)%(24*60*60))/(60*60) <= this.string2temps(this.props.parent.state.heureDebut) &&
                  ((parseInt(item.fin)%(24*60*60))/(60*60)+(24*3600) >= this.string2temps(this.props.parent.state.heureFin))
                )


              }).map(i => {
                if (
                  ((parseInt(i.debut)%(24*60*60))/(60*60) <= this.string2temps(this.props.parent.state.heureDebut) &&
                ((parseInt(i.fin)%(24*60*60))/(60*60)==0 || (parseInt(i.fin)%(24*60*60))/(60*60) >= this.string2temps(this.props.parent.state.heureFin)))
                || (parseInt(i.fin)%(24*60*60))<(parseInt(i.debut)%(24*60*60)) && 
                    (parseInt(i.debut)%(24*60*60))/(60*60) <= this.string2temps(this.props.parent.state.heureDebut) &&
                    ((parseInt(i.fin)%(24*60*60))/(60*60)+(24*3600) >= this.string2temps(this.props.parent.state.heureFin))

                ) {
                  return Object.assign({}, {
                    fin: i.fin,
                    debut: i.debut,
                    defineddebut: Math.floor(i.debut/(60*60*24))*(60*60*24) + this.string2temps(this.props.parent.state.heureDebut)*60*60,
                    definedfin:  Math.floor(i.fin/(60*60*24))*(60*60*24) + this.string2temps(this.props.parent.state.heureFin)*60*60,
                    plateau: +i.plateau,
                    exact: 1
                  })
                }
                else return Object.assign({}, {
                  fin: i.fin,
                  debut: i.debut,
                  defineddebut: i.debut,
                  definedfin:  i.fin,
                  plateau: i.plateau, 
                  exact: 0
                });
              }).map((i,index)=>{
                let checked = ((parseInt(i.debut)%(24*60*60))/(60*60) <= this.string2temps(this.props.parent.state.heureDebut) &&
                ((parseInt(i.fin)%(24*60*60))/(60*60)==0 || (parseInt(i.fin)%(24*60*60))/(60*60) >= this.string2temps(this.props.parent.state.heureFin)));
                return (
                  <tr className={((i.plateau+"-"+i.debut+"-"+i.fin === this.state.plagechoix) ? 'selected' : '') }key={i.plateau+"-"+i.debut+"-"+i.fin} data-a={i.plateau+"-"+i.defineddebut+"-"+i.definedfin} onClick={(e)=>{ 
                    this.setState({
                      plagechoix: i.plateau+"-"+i.defineddebut+"-"+i.definedfin,

                    })
                    this.props.parent.setState({
                      exact: (i.exact) ? true : false
                    })
                  }} >
                  <td>{window.plateaux.filter(p=>(i.plateau==parseInt(p.ID))).map(j=>j.name)}</td>
                  <td>{moment.utc(i.defineddebut*1000).format('H:mm')}-{moment.utc(i.definedfin*1000).format('H:mm')}</td>
                  <td><button className="arrowBtn" onClick={ (e)=>{

                      this.setState({
                        plagechoix: i.plateau+"-"+i.debut+"-"+i.fin,
                        exact: (i.exact) ? true : false
                      })
                      this.props.parent.setState({
                        exact: (i.exact) ? true : false,
                        view: (i.exact) ? 3 : 2,
                        aReserver: (i.exact) ? [{
                          debut: i.defineddebut,
                          fin: i.definedfin, 
                          plateau: i.plateau,
                        }] : [{
                          debut: i.debut,
                          fin: i.fin, 
                          plateau: i.plateau,
                        }]
                      })
                    } }></button></td>
                  <td></td>
                  </tr>
                )
              }
            )}
          </tbody>
        </table>
      </div>
    )
  }
}
export default ReservationSeuleJour;



// WEBPACK FOOTER //
// ./src/ReservationSeule2.js